export const PHONE_VALIDATION_REGEX =
  /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/

export const CEP_VALIDATION_REGEX = /^\d{5}-\d{3}$/

export const ONLY_LETTERS_REGEX = /^[a-zA-ZÀ-ÿ\s.]+$/i

export const NAME_VALIDATION_REGEX = /^[a-zA-ZÀ-ÿ\s.]+$/i
